/* ============
 * Getters for the cvc module
 * ============
 *
 * The getters that are available on the
 * cvc module.
 */

export default {
  userInfo: state => { return state.user },
  cvcInfo: state => { return state.cvcParams }
}



// WEBPACK FOOTER //
// ./src/store/modules/cvc/getters.js